/**
 * So tên tệp máy ảnh kiểu tự nhiên — CÙNG LUẬT `naturalLess` của máy chủ
 * (backend/internal/core/gallery/natural_sort.go, QĐ 0266 §7c): khúc số so theo
 * GIÁ TRỊ (IMG_9 < IMG_10), khúc chữ so không phân biệt hoa thường (chữ ASCII),
 * hai tên bằng nhau theo luật này thì so nguyên văn.
 *
 * Hai TẤM trùng tên y hệt (hai máy ảnh cùng đặt IMG_0001.jpg) thì tên không phân
 * định được: dùng `naturalCompareAssets`, so thêm mã tấm như chuỗi — đúng
 * `splitAssetLess` của máy chủ (group_staff.go). Màn "Chia theo người" xếp lưới
 * bằng hàm đó; máy chủ chia bằng hàm kia. Hai bên lệch nhau là thợ nhìn một thứ
 * tự mà máy chia theo thứ tự khác — sửa một bên phải sửa bên kia.
 */
export function naturalCompare(a: string, b: string): number {
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    const ca = a.charCodeAt(i);
    const cb = b.charCodeAt(j);
    if (isDigit(ca) && isDigit(cb)) {
      const si = i;
      const sj = j;
      while (i < a.length && isDigit(a.charCodeAt(i))) i++;
      while (j < b.length && isDigit(b.charCodeAt(j))) j++;
      const na = a.slice(si, i).replace(/^0+/, "");
      const nb = b.slice(sj, j).replace(/^0+/, "");
      if (na.length !== nb.length) return na.length - nb.length;
      if (na !== nb) return na < nb ? -1 : 1;
      continue;
    }
    const la = lowerASCII(ca);
    const lb = lowerASCII(cb);
    if (la !== lb) return la - lb;
    i++;
    j++;
  }
  const ra = a.length - i;
  const rb = b.length - j;
  if (ra !== rb) return ra - rb;
  return a < b ? -1 : a > b ? 1 : 0;
}

/** Thứ tự xếp của một tấm: theo tên tự nhiên, trùng tên y hệt thì theo mã tấm (so chuỗi). */
export function naturalCompareAssets(
  a: { ten: string; id: string },
  b: { ten: string; id: string },
): number {
  if (a.ten === b.ten) return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
  return naturalCompare(a.ten, b.ten);
}

function isDigit(c: number): boolean {
  return c >= 48 && c <= 57;
}

function lowerASCII(c: number): number {
  return c >= 65 && c <= 90 ? c + 32 : c;
}
